// extracted by mini-css-extract-plugin
export default {"tags-view":"tags-view__VjIWv","__nowrap":"__nowrap__xf1fM"};